import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react';

//ICONS
import {
  BsPaperclip,
  BsFillExclamationTriangleFill,
  BsXLg,
} from 'react-icons/bs';

//API
import tumBasvurular from '../../services/tumBasvurular';
import basvuruUpdate from '../../services/basvuruUpdate';
import basvuruDelete from '../../services/basvuruDelete';
import donemler from '../../services/donemler';
import aktifDonemAPI from '../../services/aktifDonem';
import downloadAPI from '../../services/download';
import alldownloadAPI from '../../services/alldownload';

const Basvurular = () => {
  let navigate = useNavigate();

  //MODAL State
  const [open, setOpen] = useState(false);
  const [openAciklama, setOpenAciklama] = useState(false);
  const [openDetay, setOpenDetay] = useState(false);
  const [aciklama, setAciklama] = useState('');
  const [basvuruId, setBasvuruId] = useState();
  const [basvuruListesi, setBasvuruListesi] = useState();

  const [basvuruDetay, setBasvuruDetay] = useState();

  const [selectedAktifDonemId, setSelectedAktifDonemId] = useState(0);
  const [donemlerListe, setDonemlerListe] = useState();

  const handleBavuruDurum = async (basvuruId, basvuruDurumu) => {
    let data = {
      basvuruDurumu: basvuruDurumu,
    };
    const result = await basvuruUpdate(basvuruId, data);
    if (result.status === 204) {
      toast.success('Başvuru kabul edildi', {
        position: toast.POSITION.TOP_CENTER,
      });
      getTumBasvurular();
    } else {
      toast.error('Beklenmeyen bir hata oluştu.', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleBavuruRed = async () => {
    if (aciklama === '') {
      return toast.warning('Lütfen açıklama metni giriniz', {
        position: toast.POSITION.TOP_CENTER,
      });
    }

    let data = {
      basvuruDurumAciklama: aciklama,
      basvuruDurumu: '2',
    };
    const result = await basvuruUpdate(basvuruId, data);
    if (result.status === 204) {
      toast.success('Başvuru red edildi', {
        position: toast.POSITION.TOP_CENTER,
      });
      setBasvuruId('');
      setOpenAciklama(false);
      setAciklama('');
      getTumBasvurular();
    } else {
      toast.error('Beklenmeyen bir hata oluştu.', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleBasvuruDelete = async (basvuruId) => {
    const result = await basvuruDelete(basvuruId);
    if (result.status === 200) {
      toast.success(result.data, {
        position: toast.POSITION.TOP_CENTER,
      });
      setOpen(false);
      setBasvuruId();
      getTumBasvurular();
    } else {
      toast.error('Beklenmeyen bir hata oluştu.', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleBasvuruDetay = (id) => {
    const filteredData = basvuruListesi.filter(
      (basvuru) => basvuru.basvuruId === id
    );
    setBasvuruDetay(filteredData);
    setOpenDetay(true);
  };

  const getTumBasvurular = async () => {
    const result = await tumBasvurular();
    if (result.status === 200) {
      setBasvuruListesi(result.data);
    } else {
      navigate('/auth/login');
    }
  };

  const getTumDonemler = async () => {
    const result = await donemler();
    if (result.status === 200) {
      setDonemlerListe(result.data);
    } else {
      navigate('/auth/login');
    }
  };

  const getAktifDonem = async () => {
    const result = await aktifDonemAPI();
    setSelectedAktifDonemId(result.donemId);
  };

  const handleFileDownload = async (basvuruId, filename) => {
    await downloadAPI(basvuruId, filename);
  };
  const handleFileDownload2 = async (basvuruId) => {
    await alldownloadAPI(basvuruId);
  };

  useEffect(() => {
    document.title = 'Başvuru Listesi';
    getAktifDonem();
    getTumDonemler();
    getTumBasvurular();
    //eslint-disable-next-line
  }, []);

  return (
    <main className="text-slate-500 text-sm">
      <ToastContainer />
      <div className="py-5">
        <div className="w-full px-4 sm:px-6 md:px-8">
          <div className="container mx-auto">
            <h1 className="page-title leading-6 font-normal text-lg mb-6 text-slate-500 ">
              Başvuru Listesi
            </h1>
          </div>
          <div className="container mx-auto bg-white rounded-lg">
            <div className="w-full flex flex-col md:flex-row justify-between items-cente px-4 py-6 gap-3">
              <div className="w-full md:w-1/3">
                <select
                  value={selectedAktifDonemId}
                  onChange={(e) => {
                    setSelectedAktifDonemId(e.target.value);
                  }}
                  id="donemler"
                  className="w-full  border border-slate-300 cursor-pointer  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all"
                >
                  <option value={0}>Dönem Seçiniz</option>
                  {donemlerListe &&
                    donemlerListe.map((item) => (
                      <option key={item.donemId} value={item.donemId}>
                        {item.donemName}
                      </option>
                    ))}
                </select>
              </div>
              {/* <div className='w-full md:w-1/3'>
                                <input onChange={(e)=>{handleSearchData(e.target.value)}} type='text' placeholder='Aranacak kelime' className='w-full  border border-slate-300 cursor-pointer  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'/>
                            </div> */}
            </div>
          </div>
          {basvuruListesi ? (
            <section className="container mx-auto">
              <div className="flex flex-col">
                <div className=" overflow-x-auto">
                  <div className="inline-block min-w-full py-2 align-middle">
                    <div className="overflow-hidden border border-slate-200  md:rounded-lg">
                      <table className="min-w-full divide-y divide-slate-200 ">
                        <thead className="bg-slate-50 ">
                          <tr>
                            <th
                              scope="col"
                              className="py-3.5 px-4 text-sm font-normal text-left rtl:text-right text-slate-500 "
                            >
                              <div className="flex items-center gap-x-3">
                                <span>Başvuru No</span>
                              </div>
                            </th>

                            <th
                              scope="col"
                              className="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-slate-500 "
                            >
                              Başvuru Türü
                            </th>
                            <th
                              scope="col"
                              className="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-slate-500 "
                            >
                              Araştırmacı
                            </th>

                            <th
                              scope="col"
                              className="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-slate-500 "
                            >
                              Fakülte/Yüksekokul/Enstitü
                            </th>
                            <th
                              scope="col"
                              className="px-4 py-3.5 text-sm font-normal text-left rtl:text-right text-slate-500 "
                            >
                              Durum
                            </th>

                            <th scope="col" className="relative py-3.5 px-4">
                              <span className="sr-only">Actions</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-slate-200  ">
                          {basvuruListesi
                            .filter(
                              (item) => item.donemId === +selectedAktifDonemId
                            )
                            .map((item, key) => (
                              <tr key={key}>
                                <td className="px-4 py-4 text-sm font-medium text-slate-700 whitespace-nowrap">
                                  <div className="inline-flex items-center gap-x-3">
                                    <button
                                      onClick={() =>
                                        handleBasvuruDetay(item.basvuruId)
                                      }
                                    >
                                      <span>#{item.basvuruNo}</span>
                                    </button>
                                  </div>
                                </td>
                                <td className="px-4 py-4 text-sm text-slate-500  whitespace-nowrap">
                                  {item.basvurumerkezi}
                                </td>

                                <td className="px-4 py-4 text-sm text-slate-500  whitespace-nowrap">
                                  <div className="flex items-center gap-x-2">
                                    <div>
                                      <h2 className="text-sm font-medium text-slate-800 ">
                                        {item.arastirmaciAdiSoyadi}
                                      </h2>
                                      <p className="text-xs font-normal text-slate-600 ">
                                        {item.ePosta}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td className="px-4 py-4 text-sm text-slate-500  whitespace-nowrap">
                                  {item.arastimaciFYE}
                                </td>
                                <td className="px-4 py-4 text-sm font-medium text-slate-700 whitespace-nowrap">
                                  {(() => {
                                    if (item.basvuruDurumu === '0') {
                                      return (
                                        <div className="inline-flex items-center px-3 py-1 rounded-full gap-x-2 text-orange-500 bg-orange-100/60 ">
                                          <h2 className="text-sm font-normal">
                                            Bekliyor
                                          </h2>
                                        </div>
                                      );
                                    } else if (item.basvuruDurumu === '1') {
                                      return (
                                        <div className="inline-flex items-center px-3 py-1 rounded-full gap-x-2 text-emerald-500 bg-emerald-100/60 ">
                                          <h2 className="text-sm font-normal">
                                            Kabul Edildi
                                          </h2>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="inline-flex items-center px-3 py-1 rounded-full gap-x-2 text-red-500 bg-red-100/60 ">
                                          <h2 className="text-sm font-normal">
                                            Reddedildi
                                          </h2>
                                        </div>
                                      );
                                    }
                                  })()}
                                </td>
                                <td className="px-4 py-4 text-sm whitespace-nowrap">
                                  <div className="flex items-center gap-x-6">
                                    <button
                                      onClick={() => {
                                        handleBavuruDurum(item.basvuruId, '1');
                                      }}
                                      className="text-slate-500 transition-colors duration-200   hover:text-indigo-500 focus:outline-none"
                                    >
                                      Kabul Et
                                    </button>
                                    <button
                                      onClick={() => {
                                        setOpenAciklama(true);
                                        setBasvuruId(item.basvuruId);
                                      }}
                                      className="text-slate-500 transition-colors duration-200   hover:text-indigo-500 focus:outline-none"
                                    >
                                      Reddet
                                    </button>
                                    <button
                                      onClick={() => {
                                        setOpen(true);
                                        setBasvuruId(item.basvuruId);
                                      }}
                                      className="text-xs h-8 text-white bg-red-500 border-transparent border hover:border-red-400 hover:bg-red-500/80 leading-3 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all"
                                    >
                                      Sil
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : null}
        </div>
      </div>

      {/* MODAL -------------------------------------------------- */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      className="rounded-md bg-white text-slate-400 hover:text-slate-500 "
                      onClick={() => setOpen(false)}
                    >
                      <span className="sr-only">Close</span>
                      <BsXLg className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <BsFillExclamationTriangleFill
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold leading-6 text-slate-900"
                      >
                        UYARI!
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-slate-500">
                          Başvuruyu silmek üzeresiniz. Emin misiniz?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      onClick={() => handleBasvuruDelete(basvuruId)}
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Evet
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-300 hover:bg-slate-50 sm:mt-0 sm:w-auto"
                      onClick={() => setOpen(false)}
                    >
                      İptal
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={openAciklama} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={setOpenAciklama}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      className="rounded-md bg-white text-slate-400 hover:text-slate-500 "
                      onClick={() => setOpenAciklama(false)}
                    >
                      <span className="sr-only">Close</span>
                      <BsXLg className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <BsFillExclamationTriangleFill
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold leading-6 text-slate-900"
                      >
                        Başvuru Red Edilecektir!
                      </Dialog.Title>
                      <div className="mt-2">
                        <input
                          onChange={(e) => {
                            setAciklama(e.target.value);
                          }}
                          type="text"
                          className="w-full  border border-slate-300  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all"
                        />
                        <p className="text-sm text-slate-500">
                          Başvuruyu red edilecektir. Emin misiniz?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      onClick={() => handleBavuruRed()}
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Evet
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-300 hover:bg-slate-50 sm:mt-0 sm:w-auto"
                      onClick={() => setOpenAciklama(false)}
                    >
                      İptal
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* /**OVERLAY */}
      <Transition.Root show={openDetay} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={setOpenDetay}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-3xl">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="font-semibold text-xl text-slate-600">
                            {basvuruDetay && basvuruDetay[0].basvuruNo}
                          </Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="rounded-md bg-white text-gray-400 hover:text-slate-500"
                              onClick={() => setOpenDetay(false)}
                            >
                              <span className="sr-only">Close panel</span>
                              <BsXLg className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 px-4 sm:px-6">
                        <div className="flex gap-3 text-sm w-full text-slate-500">
                          {basvuruDetay ? (
                            <div className="flex w-full flex-col gap-2">
                              <div className="text-slate-600 font-semibold text-lg">
                                Sorumlu Araştırmacı
                              </div>
                              <div>
                                {basvuruDetay[0].arastimarciUnvani}{' '}
                                {basvuruDetay[0].arastirmaciAdiSoyadi}
                              </div>
                              <div>
                                {basvuruDetay[0].arastimaciFYE},{' '}
                                {basvuruDetay[0].arastimaciBolumAnabilimDali}
                              </div>
                              <div>
                                Eposta : {basvuruDetay[0].ePosta}, Telefon :{' '}
                                {basvuruDetay[0].telefon}, Adres:{' '}
                                {basvuruDetay[0].adres}
                              </div>
                              <div className="text-slate-600 font-semibold text-lg">
                                Başvuru Bilgileri
                              </div>
                              <div>
                                <em className="font-semibold">Başvuru Türü:</em>{' '}
                                {basvuruDetay[0].basvurumerkezi},
                                <em className="font-semibold">Çalışma Dili:</em>{' '}
                                {basvuruDetay[0].arastirmaDili},
                                <em className="font-semibold">Çalışma Türü:</em>{' '}
                                {basvuruDetay[0].calismaTuru}
                              </div>
                              <div>
                                <em className="font-semibold">
                                  Araştırma Başlığı TR:
                                </em>{' '}
                                {basvuruDetay[0].arastirmaBasligiTR}
                              </div>
                              {basvuruDetay[0].arastirmaBasligiEN ? (
                                <div>
                                  <em className="font-semibold">
                                    Araştırma Başlığı EN:
                                  </em>{' '}
                                  {basvuruDetay[0].arastirmaBasligiEN}
                                </div>
                              ) : (
                                ''
                              )}

                              {basvuruDetay[0].yardimciArastirmaci &&
                                basvuruDetay[0].yardimciArastirmaci[0].map(
                                  (item, key) => (
                                    <Fragment key={key}>
                                      <div className="text-slate-600 font-semibold text-lg">
                                        Yardımcı Araştırmacı
                                      </div>
                                      <div>
                                        {item.yrdArastimarciUnvani}{' '}
                                        {item.yrdArastirmaciAdiSoyadi}
                                      </div>
                                      <div>
                                        {item.yrdArastimaciFYE}{' '}
                                        {item.yrdArastimaciBolumAnabilimDali}
                                      </div>
                                      <div>
                                        Eposta : {item.yrdEPosta}, Telefon :{' '}
                                        {item.yrdTelefon}, Adres:{' '}
                                        {item.yrdAdres}
                                      </div>
                                    </Fragment>
                                  )
                                )}
                              <div className="flex flex-col items-start gap-y-2">
                                <div className="text-slate-600 font-semibold text-lg">
                                  Dosyalar
                                </div>
                                {basvuruDetay && (
                                  <a
                                    href={`https://egitimetikbasvuru.odu.edu.tr/form-print/${basvuruDetay[0].basvuruNo}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="inline-flex items-center"
                                  >
                                    <BsPaperclip className="text-lg" /> Başvuru
                                    Formu
                                  </a>
                                )}
                                {basvuruDetay[0].basvuruDilekcesiFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0].basvuruDilekcesiFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Başvuru
                                    Dilekçesi
                                  </button>
                                )}
                                {basvuruDetay[0].ozgecmisFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0].ozgecmisFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Özgeçmiş
                                  </button>
                                )}
                                {basvuruDetay[0].kurulKarariFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0].kurulKarariFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" />{' '}
                                    Enstitü/Anabilim Dalı Kurul Kararı
                                  </button>
                                )}
                                {basvuruDetay[0].veliOnamFormuFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0].veliOnamFormuFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Veli
                                    Onam Formu
                                  </button>
                                )}
                                {basvuruDetay[0].gonulluOnamFormuFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0].gonulluOnamFormuFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Gönüllü
                                    Onam Formu
                                  </button>
                                )}
                                {basvuruDetay[0].veriToplamaAraclariFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0].veriToplamaAraclariFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Veri
                                    Toplama Araçları
                                  </button>
                                )}
                                {basvuruDetay[0].veriToplamaIzinYazisiFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0]
                                          .veriToplamaIzinYazisiFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Veri
                                    toplama aracı açık erişime sahip değilse
                                    izin yazısı
                                  </button>
                                )}
                                {basvuruDetay[0].veriToplamaAraclariEkFile && (
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload(
                                        basvuruDetay[0].basvuruId,
                                        basvuruDetay[0]
                                          .veriToplamaAraclariEkFile
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Veri
                                    toplama aracı diğer dosya
                                  </button>
                                )}
                                {
                                  <button
                                    className="inline-flex items-center"
                                    onClick={() => {
                                      handleFileDownload2(
                                        basvuruDetay[0].basvuruId
                                      );
                                    }}
                                  >
                                    <BsPaperclip className="text-lg" /> Tümünü
                                    İndir
                                  </button>
                                }
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </main>
  );
};

export default Basvurular;
